import { useCallback, useEffect } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { ParallaxScrollView } from '../src/components/animations';
import { AutomationShowcase } from '../src/components/landing/AutomationShowcase';
import { useSectionView } from '../src/components/landing/hooks/useSectionView';
import { LandingHeader } from '../src/components/landing/LandingHeader';
import { GridBackdrop } from '../src/components/landing/landingStyleKit';
import { PremiumCTASection } from '../src/components/landing/PremiumCTASection';
import { PremiumFeaturesSection } from '../src/components/landing/PremiumFeaturesSection';
import { PremiumFooter } from '../src/components/landing/PremiumFooter';
import { PremiumHeroSection } from '../src/components/landing/PremiumHeroSection';
import { PricingSection } from '../src/components/landing/PricingSection';
import { useAccessGate } from '../src/hooks/useAccessGate';
import { trackEvent } from '../src/lib/analytics';
import { useMixpanel } from '../src/lib/mixpanel';
import { colors } from '../src/theme/colors';

export default function LandingPage() {
  const { destination } = useAccessGate();
  const mp = useMixpanel();

  useEffect(() => {
    trackEvent(mp, 'landing.viewed', {});
  }, [mp]);

  useSectionView(
    'features',
    useCallback(() => trackEvent(mp, 'landing.section_viewed', { section: 'features' }), [mp]),
  );
  useSectionView(
    'workflow',
    useCallback(() => trackEvent(mp, 'landing.section_viewed', { section: 'workflow' }), [mp]),
  );
  useSectionView(
    'pricing',
    useCallback(() => trackEvent(mp, 'landing.section_viewed', { section: 'pricing' }), [mp]),
  );

  return (
    <View style={styles.wrapper}>
      <GridBackdrop />
      {Platform.OS === 'web' && <LandingHeader destination={destination} />}
      <ParallaxScrollView style={styles.container} contentContainerStyle={styles.content}>
        <PremiumHeroSection destination={destination} />
        <View nativeID="features">
          <PremiumFeaturesSection />
        </View>
        <View nativeID="workflow">
          <AutomationShowcase />
        </View>
        <View nativeID="pricing">
          <PricingSection destination={destination} />
        </View>
        <View nativeID="integrations">
          <PremiumCTASection destination={destination} />
        </View>
        <PremiumFooter />
      </ParallaxScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    backgroundColor: colors.background.primary,
  },
  container: {
    flex: 1,
    backgroundColor: colors.transparent,
  },
  content: {
    flexGrow: 1,
  },
});
